import { Cable, Plus } from "lucide-react";

import { Button } from "@/design-system/components/Button/Button";

type Props = {
  isFiltered?: boolean;
  onCreateNew: () => void;
};

export function DataConnectorListEmptyState({
  isFiltered,
  onCreateNew,
}: Props) {
  const heading = isFiltered
    ? "No data connectors match your search"
    : "No data connectors configured";
  const body = isFiltered
    ? "Try a different search term."
    : "Connect data from external systems to Freshpaint.";

  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center text-center">
      <div className="bg-surface-selected mb-6 flex h-24 w-24 items-center justify-center rounded-full">
        <Cable className="h-10 w-10 text-blue-400" strokeWidth={1.5} />
      </div>
      <h3 className="text-textDefault mb-2 text-lg font-semibold">{heading}</h3>
      <p className="text-textSubtle mb-6 max-w-sm text-sm">{body}</p>
      {!isFiltered && (
        <Button leadingIcon={<Plus size={16} />} onClick={onCreateNew}>
          Create data connector
        </Button>
      )}
    </div>
  );
}
